export default __webpack_public_path__ + "assets/pencil.svg";